import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const CfgCtx = createContext({ features: {}, colors: null, announcement: null, app_links: { android: "", ios: "" }, auction: null });

export const useSiteConfig = () => useContext(CfgCtx);

const shade = (hex, f = 0.85) => {
  const m = /^#([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const r = Math.round(((n >> 16) & 255) * f);
  const g = Math.round(((n >> 8) & 255) * f);
  const b = Math.round((n & 255) * f);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState({ features: {}, colors: null, announcement: null, app_links: { android: "", ios: "" }, auction: null });

  useEffect(() => {
    api("/config")
      .then((c) => {
        const f = c.features || {};
        setCfg((prev) => ({
          ...prev,
          features: {
            live: f.live_shopping ?? f.live ?? true,
            cart: f.cart ?? true,
            flash_deals: f.flash_deals ?? true,
            rfq: f.rfq ?? true,
            orders: f.orders ?? true,
            reels: f.reels ?? true,
          },
          colors: c.colors || null,
          announcement: c.announcement || null,
          app_links: {
            android: c.android_url || c.app_android || c.play_store_url || c.android || c.app_links?.android || "",
            ios: c.ios_url || c.app_ios || c.app_store_url || c.ios || c.app_links?.ios || "",
          },
        }));
      })
      .catch(() => {});
    api("/auctions/home")
      .then((a) => setCfg((prev) => ({ ...prev, auction: a })))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const primary = cfg.colors?.btn_primary;
    const bg = cfg.colors?.bg_color || cfg.colors?.background;
    let tag = document.getElementById("admin-theme");
    if (!primary && !bg) {
      tag?.remove();
      document.body.style.backgroundColor = "";
      return;
    }
    if (!tag) {
      tag = document.createElement("style");
      tag.id = "admin-theme";
      document.head.appendChild(tag);
    }
    tag.textContent = `${primary ? `:root{--ap:${primary}}.bg-teal-700{background-color:${primary}!important}.hover\\:bg-teal-800:hover{background-color:${shade(primary)}!important}.shadow-teal-700\\/25{--tw-shadow-color:${primary}40!important}` : ""}${
      bg ? `:root{--app-bg:${bg}}.App,[data-testid="home-page"]{background-color:${bg}!important}` : ""
    }`;
    document.body.style.backgroundColor = bg || "";
  }, [cfg.colors]);

  return <CfgCtx.Provider value={cfg}>{children}</CfgCtx.Provider>;
}
